import {UrlBuilder} from "../../../common/utils/url";
import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property, query} from "lit/decorators.js";
import Styles from "./newsTagLink.lit.scss";
import {SEARCH_QUERY_PARAMETER_NAME} from "./constants";
import {ShadowHighlightContextAware} from "../../../common/elements";
import {trackingTextlinkInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-news-tag-link")
export class EopNewsTagLink extends ShadowHighlightContextAware(LitElement) {

    public static readonly styles = Styles;

    @property()
    private url: string;
    @property()
    private text: string;

    @query("a")
    private linkElement: HTMLElement;

    public render(): TemplateResult {
        const url = this.getTargetUrl();

        return html`
            <div class="tag-container reverse-background">
                <a href=${url} class="tag" ${trackingTextlinkInteract(this.text, url)} @keydown=${this.preventTriggeringParentTile}>${this.text}</a>
            </div>
        `;
    }

    private preventTriggeringParentTile(event: KeyboardEvent): void {
        event.stopPropagation();
    }

    private getTargetUrl(): string {
        return new UrlBuilder(this.url)
            .withQueryParameter(SEARCH_QUERY_PARAMETER_NAME, this.text)
            .build();
    }

    public focusableElement(): HTMLElement {
        return this.linkElement;
    }
}